import React, { Fragment, useEffect, useState } from "react"
import { loadTexts, sanitize } from "../../utils/i18n"

import "./index.less"
import { Tag, Tooltip, Row, Col } from "antd"

const PreviewPDAWithIA = (props) => {
  const { dimension_name,dimension_color,value_visible,division_name, pdaData } = props;
  const intl = loadTexts("dashboard");



  const [clickedIndex, setClickedIndex] = useState(0);

  const renderSelectedRowDimension = () => {
    if (dimension_name && dimension_color && value_visible) {

      return (
        <Fragment>
          {dimension_name} <Tag color={dimension_color}>{value_visible}</Tag>
        </Fragment>
      );
    } else {
      // Establecer valores por defecto
      const defaultName = "Entorno Fisico";
      const defaultValue = "74%";
      return (
        <Fragment>
          {defaultName} <Tag color="#fed86f">{defaultValue}</Tag>
        </Fragment>

      );
    }
  };

  // Función para manejar el clic en un elemento de la lista
  const handleItemClick = (index) => {
    setClickedIndex(index); // Guarda el índice del elemento clickeado en el estado

    const newPdaData = pdaData.map((item, i) => {
      if (i === index) {
        return { ...item, selected: true }; // Marca como seleccionado el elemento en el índice especificado
      } else {
        return { ...item, selected: false }; // Marca como no seleccionado los demás elementos
      }
    });

    props.setStateFrom("pdaData", newPdaData);


  };

  const renderSelectedDataGa = () => {
    const selectedData = pdaData[clickedIndex];
    return (
      <div >
        <Row>
          <Col span={24}>
            <h4 style={{ fontSize: "14px",  color: "#4F4F4F" }}>{intl.previewActionPlanIA.title}</h4>
            <div className="preview-container">
              {selectedData.nombreDePlan ?? ''}
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <h4 style={{ fontSize: "14px",  color: "#4F4F4F" }}>{intl.previewActionPlanIA.description}</h4>
            <div className="preview-container">
              {selectedData.descripcion ?? ''}
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24} className="preview-container-list">
            <h4 style={{ fontSize: "14px",  color: "#4F4F4F" }}>{intl.previewActionPlanIA.tasks}</h4>
            <ol>
              {selectedData.acciones.map((accion, index) => (
                <li className="preview-container preview-container-task" key={index}>{accion.accion}</li>
              ))}
            </ol>
          </Col>
        </Row>



      </div>
    );
  };

  return (
    <Fragment>
      <div >
        <Row>
          <Col style={{
            backgroundColor: "#F9F9F9", paddingLeft: "18px", borderBottom: "1px solid #f0f0f0",
            paddingRight: "8px", paddingTop: "12px", paddingBottom: "14px", display: 'flex', flexDirection: 'column', justifyContent: 'space-between'
          }} span={6}>
            <div >
              <span style={{ color: "#979797" }}> {intl.previewActionPlanIA.sugerenciasGeneradas}</span>

              <ol className="preview-container-list-custom">
                {pdaData.length > 0 && pdaData.map((pda, index) => (
                  <li
                    style={{ cursor: "pointer" }}
                    key={index}
                    onClick={() => handleItemClick(index)} // Llama a la función handleItemClick con el índice como argumento
                  >
                    <span className="preview-container-list-custom-number">{(pdaData.length) - index}.</span>

                    <Tooltip  title={ pda.nombreDePlan.length < 20 ? '' :pda.nombreDePlan} placement="right">
                    <div className={`${pda.selected ? "preview-container-sugerencia preview-container-sugerencia-onClick" : "preview-container-sugerencia"}`}>
                      <span style={{ opacity: 1, marginLeft: "12px" }}>
                        {pda.nombreDePlan.length > 20 ? `${pda.nombreDePlan.substring(0, 20)}...` : pda.nombreDePlan}
                      </span>
                    </div>
                    </Tooltip>
                  </li>
                ))}
              </ol>
            </div>
            <div style={{lineHeight: 1.3}}>


              <span className="preview-container-sugerencia-text">{sanitize(intl.previewActionPlanIA.infoPreviewViewStepOne)}</span>{" "}
              <span className="preview-container-sugerencia-text">{sanitize(intl.previewActionPlanIA.infoPreviewViewStepTwo)}</span>{" "}
              <span className="preview-container-sugerencia-text">{intl.previewActionPlanIA.infoPreviewViewStepThree}</span> <br></br>
              <span className="preview-container-sugerencia-text">{intl.previewActionPlanIA.infoPreviewViewStepFour}</span> {"   "}
              <span className="preview-container-sugerencia-text">{intl.previewActionPlanIA.infoPreviewViewStepFive}</span>
            </div>
          </Col>
          <Col style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop: "12px", paddingBottom: "10px", borderBottom:"1px solid #f0f0f0" }} span={18}>
            <Row>
              <Col span={12}>
                <h4 style={{ fontSize: "14px",  color: "#4F4F4F"  }}>{intl.previewActionPlanIA.dimensionsRow}</h4>
                <div className="preview-container">
                  {renderSelectedRowDimension()}
                </div>
              </Col>
              <Col span={12}>
                <h4 style={{ fontSize: "14px",  color: "#4F4F4F"  }}>{intl.previewActionPlanIA.divisonRow}</h4>
                <div className="preview-container">{division_name}</div>
              </Col>
            </Row>
            {renderSelectedDataGa()}

          </Col>
        </Row>
      </div>
    </Fragment>
  );
};

export default PreviewPDAWithIA;


